import React, { Component } from "react";
import COLORS from "scss/colors.module.scss";
import { Checkbox, ListItem } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { FaExpandArrowsAlt } from "react-icons/fa";
import styled, { css } from "styled-components";

import chroma from "chroma-js";

export default class CheckboxGroupColumnEditor extends Component {
  constructor(props) {
    super(props);
    var options = [];
    var columnOptions = props.colDef?.cellRendererParams?.columnOptions;
    columnOptions.options.map((option, index) => {
      options.push({
        value: typeof option == "string" ? option.trim() : option,
        label: typeof option == "string" ? option.trim() : option,
        color: columnOptions.colors ? columnOptions.colors[index] : "#808080",
      });
      return 0;
    });
    this.state = {
      options: options,
      selectedOption: props.value,
      top: false,
      bottom: false,
      editorModal: false,
    };
    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(
      this
    );
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleChange = (selectedOption) => {
    var data = [];
    let selectedValues = this.state.selectedOption
      ? this.state.selectedOption.split(",")
      : [];
    for (let i = 0; i < selectedValues.length; i++) {
      selectedValues[i] = selectedValues[i].trim();
      data.push(selectedValues[i]);
    }
    if (data.includes(selectedOption.value)) {
      data = data.filter((item) => item !== selectedOption.value);
    } else {
      data.push(selectedOption.value);
    }

    var value = data.join(", ");
    this.props.onChange(value);
    this.setState({
      selectedOption: value,
    });
  };

  componentDidMount() {
    this.refs.container.addEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
    this.focus();
    if (
      this.state.editorModal === false &&
      this.props.colDef.store.isCheckBoxGroupDialogOpen === true
    ) {
      this.setState({ editorModal: true });
    }
  }

  componentWillUnmount() {
    this.refs.container.removeEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
    document.removeEventListener("mousedown", this.handleClickOutside);
    try {
      this.refs.container.offsetParent.style.bottom = "";
    } catch (e) {}
  }

  arrowKeyNavigation = (event) => {
    // console.log("cbg");
    if ([13].indexOf(event.keyCode) > -1) {
      event.stopPropagation();
      if (event.shiftKey) {
        this.props.api.stopEditing(false);
        this.props.api.setFocusedCell(
          this.props.rowIndex,
          this.props.column.colId
        );
      }
    }
  };

  getValue() {
    return this.state.selectedOption;
  }

  isPopup() {
    return false;
  }

  handleClickOutside(event) {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      !this.state.editorModal
    ) {
      document.removeEventListener("mousedown", this.handleClickOutside);
      this.props.api.clearRangeSelection();
      this.props.api.stopEditing(false);
      this.props.api.clearFocusedCell();
    }
  }

  focus() {
    window.setTimeout(() => {
      document.addEventListener("mousedown", this.handleClickOutside);
      if (this.refs.container &&
        window.innerHeight - this.refs.container.getBoundingClientRect().top <
        this.refs.container.getBoundingClientRect().height + 40
      ) {
        this.setState({
          top: null,
          bottom: 1,
        });
      } else {
        this.setState({
          top: this.props.node.rowHeight,
          bottom: null,
        });
      }
    });
  }

  getStyledListItem(option, index, selectedValues) {
    return (
      <StyledListItem
        className="cursor-default"
        button
        key={index}
        styledWidth={this.props.colDef.width - 20}
        onClick={() => {
          this.handleChange(option);
        }}
      >
        <StyledSvg viewBox="0 0 22 14" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            fill={option.color}
            d={
              selectedValues?.includes(option.label)
                ? "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM7 12.414l-3.707-3.707 1.414-1.414 1.293 1.293 3.793-3.793 1.414 1.414-6.207 6.207z"
                : "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM14 14h-12v-12h12v12z"
            }
          ></path>
        </StyledSvg>
        <StyledLabel
          style={{
            background: option.color,
            color:
              chroma.contrast(option.color, COLORS.PRIMARY_COLOR) > 2
                ? COLORS.PRIMARY_COLOR
                : COLORS.SECONDARY_COLOR,
          }}
        >
          {option.label}
        </StyledLabel>
      </StyledListItem>
    );
  }

  render() {
    var selectedValues = this.state.selectedOption
      ? this.state.selectedOption.split(",")
      : [];
    var valuesArrToShow = [],
      temp;
    for (let i = 0; i < selectedValues.length; i++) {
      selectedValues[i] = selectedValues[i].trim();
    }
    selectedValues.map((value) => {
      temp = this.state.options.find((option) => option.label === value);
      if (temp) valuesArrToShow.push(temp);
      return 0;
    });

    return (
      <StyledCheckBoxDiv
        ref={this.setWrapperRef}
        styledHeight={this.props.node.rowHeight - 6}
      >
        <div ref="container">
          <StyledCheckBoxInnerDiv>
            {this.state.options.map((option, index) =>
              this.getStyledListItem(option, index, selectedValues)
            )}
            <StyledExpandDiv
              className="expandArrow"
              onClick={() => {
                this.setState({ editorModal: true });
              }}
            >
              <FaExpandArrowsAlt size={14} />
            </StyledExpandDiv>
            <Dialog
              fullWidth={true}
              maxWidth={"xs"}
              open={this.state.editorModal}
              onClose={() => {
                this.setState({ editorModal: false });
                this.props.colDef.store.setIsCheckBoxGroupDialogOpen(false);
              }}
              aria-labelledby="form-dialog-title"
            >
              <DialogContent>
                {this.state.options.map((option, index) =>
                  this.getStyledListItem(option, index, selectedValues)
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    this.setState({ editorModal: false });
                    this.props.colDef.store.setIsCheckBoxGroupDialogOpen(false);
                  }}
                  color="primary"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </StyledCheckBoxInnerDiv>
          <StyledFixedDiv className="multiLineExtraText">Shift+Enter or Tab to save</StyledFixedDiv>
        </div>
      </StyledCheckBoxDiv>
    );
  }
}

const StyledCheckBoxDiv = styled.div`
  max-height: 200px;
  overflow-y: auto;
  ${(props) =>
    props.styledHeight &&
    css`
      min-height: ${props.styledHeight}px;
    `}
`;

const StyledCheckBoxInnerDiv = styled.div`
  display: inline-block;
  white-space: normal;
  line-height: normal;
`;

const StyledSvg = styled.svg`
  min-width: 17.6px;
  min-height: 17.6px;
  max-width: 17.6px;
  max-height: 17.6px;
`;

const StyledLabel = styled.label`
  background: ${COLORS.PRIMARY_COLOR};
  padding: 5px 12px 5px 12px;
  border-radius: 20px;
  color: ${COLORS.TEXT_COLOR};
`;

const StyledExpandDiv = styled.div`
  position: absolute;
  right: 5px;
  top: 5px;
`;

const StyledListItem = styled(ListItem)`
  height: auto;
  padding: 3px 0px 3px 14px;
  ${(props) =>
    props.styledWidth &&
    css`
      min-width: ${props.styledWidth}px;
    `}
`;

const StyledFixedDiv = styled.div`
  line-height: 1.3em;
  position: sticky;
  background-color: #fff;
  bottom: 0px;
`;